import angular from 'angular';
import React from 'react';
import ReactDOM from 'react-dom';
import { withProviders } from '../../../core/components';
import { PictureInPictureFrame } from './PictureInPictureFrame';
const component = {
    controller: class {
        constructor($element) {
            this.$element = $element;
        }
        $onInit() {
            ReactDOM.render(React.createElement(withProviders(PictureInPictureFrame)), this.$element[0]);
        }
        $onDestroy() {
            ReactDOM.unmountComponentAtNode(this.$element[0]);
        }
    },
};
export default angular
    .module('doxy.call.picture-in-picture-frame', [])
    .component('pictureInPictureFrame', component).name;
// picture-in-picture-frame
